import React from "react";

import AdminClientHeader from "../components/header/AdminClientHeader";
import ClientForm from "../components/form/ClientForm";
import "./AdminUserCreateClient.scss";
import { withPermission } from "hocs/withPermission";
import { canCreatePermission } from "configs/constants";

const AdminUserCreateClient = () => {
  const breadCrumbs = [
    { text: "USERS" },
    { url: "/admin/users/clients", text: "CLIENTS" },
    { text: "NEW" }
  ];
  return (
    <div className="admin-user-create-client admin-create-update-client">
      <AdminClientHeader breadCrumbs={breadCrumbs} hasButton={false} />
      <div className="admin-content form-content">
        <h2 className="title">Create Client User</h2>
        <ClientForm isNewForm={true} />
      </div>
    </div>
  );
};
export default withPermission(AdminUserCreateClient, canCreatePermission);
